import React, { useState } from 'react';
import { EditorLabel } from '../EditorLabel';
import { IEditorProps } from '../Editor';
import { useScopeHandlers } from './hooks/useScopeHandlers';
import { CountDataFilterField } from 'components/inputs/data-filters/CountDataFilterField';
import { CountFilterValue } from '@decisions/server/DecisionsFramework/Design/Page/Filters';

// import './CountDataFilterEditor.less'

export interface ICountDataFilterEditorProps extends IEditorProps {}

/**
 * Editor for a string match filter object.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function CountDataFilterEditor({ child, path, onChange, hideInputLabel }: ICountDataFilterEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as CountFilterValue);

  const onValueChange = (newValue: CountFilterValue) => {
    onChange(newValue, path);
    setValue(newValue);
  };
  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });

  return (
    <EditorLabel editor={child} path={path} hideInputLabel={hideInputLabel} doNotWrap>
      <CountDataFilterField value={value} onChange={onValueChange} personalization={personalization} />
    </EditorLabel>
  );
}
